//import runtimeEnv from '@mars/heroku-js-runtime-env';

import { default as alias } from "axios";

const handleUnauthorized = () => {
  // let dispatch = useDispatch();
  // dispatch({ type: 'LOGOUT' });
  // store.dispatch({ type: 'LOGOUT' });
  localStorage.clear();
  sessionStorage.clear();
  window.location.reload();
};

alias.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (
      error &&
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      handleUnauthorized();
    }
    if (error.message && error.message == "Request aborted") {
      let response = { errorType: "Aborted" };
      error.response = response;
      return Promise.reject(error);
    }
    if (error.response && error.response.status === 500) {
      let data = { message: "Internal server Error" };
      error.response.data = data;
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export const axios = alias;

// const env = runtimeEnv()
const env = process.env;
export const getIpAddressUrl = "https://api.ipify.org/?format=json";
// export const apiUrl = "https://api-test.exirio-dev.com"
// export const piApiUrl = "https://api-test.exirio-dev.com"
export const apiUrl = env.REACT_APP_API_URL || "https://api-pi.exirio-dev.com";
export const piApiUrl =
  env.REACT_APP_API_URL || "https://api-pi.exirio-dev.com";

export const isDev = env.REACT_APP_RUN_ENV === "development";

// export const apiUrl = "https://api-pi.exirio-dev.com"
// export const piApiUrl = "https://api-pi.exirio-dev.com"
export const securityLogoUrl =
  env.SECURITY_LOGOS_URL || "https://d3es89m66qstv7.cloudfront.net/";
export const zaboClientId =
  "UMCdamQlwwmxA988oEfI1L59WshO0pd1CW360XmVDztLZNJYdS0QFgPFZfZROvyb";

export const getToken = () => {
  let headerObj = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("tokenAdmin"),
    },
  };
  let user = JSON.parse(localStorage.getItem("ownerUser") || "null");
  if (user) {
    headerObj.headers["owner_id"] = user.user;
  }
  return headerObj;
};
export const DateFormat = "DD MMM YYYY";
export const DateTimeFormat = "DD/MM/YYYY HH:mm:ss";
export const loginCallBackOriginUrl = apiUrl;
export const assetRoutePath = "/asset/";
export const securityRoutePath = "/publicinstrument/";

export const areaChartRange = [
  {
    label: "7D",
    value: "7d",
  },
  {
    label: "1M",
    value: "1m",
  },
  {
    label: "6M",
    value: "6m",
  },
  // {
  //     label: 'YTD',
  //     value: 'ytd'
  // },
  {
    label: "1Y",
    value: "monthly",
  },
  {
    label: "5Y",
    value: "5y",
  },
  {
    label: "Max",
    value: "yearly",
  },
];
